import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { formatNumber, DateFormatter } from '../../utils/date';
import Carousel from '../carousel/carousel';
import forEach from 'lodash/forEach';
import tryActivateElem from '../timeline/scrollActivate';
import { casesRoute } from '../../routes/index';
import { Link } from 'react-router';

import Image from '../image/image';

import formatCredits from '../../utils/formatCredits';

import css from './timelineCase.scss';

import buttonWhite from './button-hover-white.png';
import buttonDark from './button-hover.png';

import { Player, PlayerTrigger } from '../video/player';

export default class TimelineCaseElement extends Component {
	static propTypes = {
		points: PropTypes.number.isRequired,
		profiles: PropTypes.array.isRequired,
		createdDate: PropTypes.string.isRequired,
		caseTypes: PropTypes.object.isRequired,
		title: PropTypes.string.isRequired,
		slide1: PropTypes.oneOfType([
			PropTypes.object.isRequired,
			PropTypes.oneOf([false]),
		]),
		slide2: PropTypes.oneOfType([
			PropTypes.object.isRequired,
			PropTypes.oneOf([false]),
		]),
		slide3: PropTypes.oneOfType([
			PropTypes.object.isRequired,
			PropTypes.oneOf([false]),
		]),
		className: PropTypes.string,
		browser: PropTypes.object.isRequired,
		awards: PropTypes.array.isRequired,
		awardId: PropTypes.number.isRequired,
		sortDate: PropTypes.string.isRequired,
		same: PropTypes.string.isRequired,
	};
	static defaultProps = {
		points: 0,
		profiles: [],
		createdDate: '',
		caseTypes: { name: '' },
		title: 'Unknown',
		slide1: '',
		className: '',
	};

	constructor(props) {
		super(props);

		this.boundingRect = false;

		//this.testbg = `rgb(${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1}, ${Math.floor(Math.random() * 255) + 1})`;
		this.state = {
			autoPlayVid: false,
			readyClick: false,
		};

		var num = Math.floor(Math.random() * 4) + 1;
	}

	componentDidMount() {
		function hasClass(element, cls) {
			return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
		}

		this.tryActivateElem = tryActivateElem(this.getElement.bind(this), this.props.browser);
		if (!this.tryActivateElem()) {
			this.props.browser.scroll.register(this.tryActivateElem);
		}
	}

	componentWillUnmount() {
		this.props.browser.scroll.deregister(this.tryActivateElem);
	}

	shouldComponentUpdate(nProps, nState) {
		return (
			//nProps.browser.window.width !== this.props.browser.window.width ||
			nProps.createdDate !== this.props.createdDate ||
			nState.showVideo !== this.state.showVideo ||
			nState.autoPlayVid	 !== this.state.autoPlayVid	 ||
			nProps.title !== this.props.title ||
			nProps.showreelUrl !== this.props.showreelUrl ||
			nProps.className !== this.props.className ||
			nProps.browser.window.width !== this.props.browser.window.width
		);
	}

	componentDidUpdate() {
		//this.boundingRect = this.refs.timelineCase.getBoundingClientRect();
	}

	render() {
		//let { title, categories, profiles, points, createdDate } = this.props.item;
		let winDate = new DateFormatter(this.props.sortDate);
		let awardTitle = '';
		let awardType = '';
		let _this = this;

		let url = casesRoute(this.props.slug);

		//console.log(casesRoute(this.props.slug));

		let month = winDate.month;

		if (this.props.browser.window.width < 1200 && this.props.browser.window.width > 719) {
			month = winDate.monthShort;
		}

		forEach(this.props.awards, function(award) {
			if (award.id == _this.props.awardId) {
				awardTitle = award.name;
				awardType = award.type;
			}
		});

		awardType = awardType.toLowerCase();

		let ribbonClass = `ribbon-${awardType} ribbon-${awardType}--small`;
		if (this.props.className == 'even') {
			ribbonClass += ` ribbon-${awardType}--bl`;
		} else {
			ribbonClass += ` ribbon-${awardType}--br`;
		}

		let imgSpan = { desktop: 'span5', tablet: 'span5', mobile: 'span10' };

		let slides = [];

		for (let i = 1; i <= 3; i++) {
			(this.props['slide' + i]) && slides.push(
				<Link to={url} key={'slide' + i}>
					<Image img={this.props['slide' + i]} span={imgSpan} alt='' browser={this.props.browser} />
				</Link>
			);
		}

		(!!this.props.showreelUrl) && slides.push(
			<PlayerTrigger ref='slideVideo' onUpdate={() => {_this.setState({..._this.state, autoPlayVid: _this.refs.slideVideo}); }} key='slideVideo' url={this.props.showreelUrl} codaClass='slide-coda__item--is-video' onClick={(e) => {
				this.setState({
					...this.state,
					showVideo: true,
				});
			}} />
		);

		return (
			<li className={'timeline__element span6 span12-mobile ' + this.props.className + ' ' + this.props.same} ref='timelineElement'>
				<time className='timeline-case__date span1 span4-mobile'>
					<span className='timeline-case__date--day'>{winDate.date}</span>
					<span className='timeline-case__date--month'>{month}</span>
				</time>
				<div className='timeline-case' ref='timelineCase'>
					<div className='timeline-case__glitter pixel-pattern clearfix'>
						<div className='span5 timeline-case__glitter-img span10-mobile'>
							<div className='timeline-case__glitter-img__buttons-container' onClick={(event) => this.caseClick(event)}>
								{this.props.url && (
								<Link to={url} className='timeline-case__glitter-img__button-light' ref='seeCase' onClick={(event) => this.caseLaunchClick(event)}>
									See Case
								</Link>
								) || (
								<Link to={url} className='timeline-case__glitter-img__button-light timeline-case__glitter-img__button-light--solo' ref='seeCase' onClick={(event) => this.caseLaunchClick(event)}>
									See Case
								</Link>
								)}
								{this.props.url && (
									<a href={this.props.url} target='_blank' className='timeline-case__glitter-img__button-dark' onClick={(event) => this.caseLaunchClick(event)}>Launch<span className='hide-mobile'> project</span> <i className='arrow'></i></a>
								)}
							</div>
							<Carousel autoplay={false} hasVideo autoPlayVid={this.state.autoPlayVid} browser={this.props.browser} sliderClass='pixel-pattern pixel-pattern--01 pixel-pattern--dark' decoClass={this.props.legacy ? 'legacy' : ''}>
								{slides}
							</Carousel>
							<div className={ribbonClass}></div>
						</div>
						<div className={'span1 span2-mobile timeline-case__glitter-scorecard' + (this.props.legacy ? ' timeline-case__glitter-scorecard--legacy' : '')}>
							{!this.props.legacy && (
								<div>
									<div className='timeline-case__glitter-scorecard__score'>
										{formatNumber(this.props.points)} <small>Points</small>
									</div>
									<div className='timeline-case__glitter-scorecard__days'>
										{this.props.days} <small>Days</small>
									</div>
								</div>
							)}

						</div>
					</div>
					<div className='timeline-case__details clearfix'>
						<div className='span5 span10-mobile timeline-case__details-holder '>
							<div className='timeline-case__details-award'>
								{awardTitle}
								<div className='timeline-case__details-award__category'>
									{this.props.caseTypes.name}
								</div>
							</div>
							<h2 className='timeline-case__details__title'><Link to={url}>{this.props.title}</Link></h2>
							<div className='timeline-case__details__profile'>{formatCredits(this.props.profiles, false)}</div>
						</div>
						<div className='span1 hide-tablet empty'></div>
					</div>
				</div>
				{(!!this.props.showreelUrl) && (
					<Player browser={this.props.browser} url={this.props.showreelUrl} showVideo={this.state.showVideo} onClose={() => { this.setState({ ...this.state, showVideo: false }); }} />
				)}
			</li>
		);
	}

	caseLaunchClick(event) {
		if (this.props.browser.window.width < 720 && !this.state.readyClick) {
			event.preventDefault();
			this.setState({...this.state, readyClick: true});
		} else if (this.props.browser.window.width < 720) {
			this.setState({...this.state, readyClick: false});
		} else {
			event.stopPropagation();
		}
	}

	caseClick(event) {

		if (this.props.browser.window.width > 719) {
			ReactDOM.findDOMNode(this.refs.seeCase).click(event);
		} else {
			this.setState({...this.state, readyClick: true});
		}
	}

	getElement() {
		return this.refs.timelineElement;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/timelinecase/timelineCase.js
 **/